export default __webpack_public_path__ + "static/media/FAQ_15_2.e1f4614c.png";